import { render, staticRenderFns } from "./PartsPages.vue?vue&type=template&id=195b6d20&"
import script from "./PartsPages.vue?vue&type=script&lang=js&"
export * from "./PartsPages.vue?vue&type=script&lang=js&"
import style0 from "./PartsPages.vue?vue&type=style&index=0&id=195b6d20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports